import React from 'react';
import ConsentCard from './ConsentCard';

const ConsentList = ({
	consents,
	selectedAccounts,
	onSelectAccount,
	onViewDetails,
	customDetails,
}) => {
	return (
		<div >
			{consents.map((consent, index) => (
				<ConsentCard
					key={index}
					consent={consent}
					isSelected={selectedAccounts
						.map((elm) => elm?.consentIntentId)
						.includes(consent.consentIntentId)}
					onSelect={onSelectAccount}
					onViewDetails={onViewDetails}
					customDetails={customDetails}
					selectedAccounts={selectedAccounts}
				/>
			))}
		</div>
	);
};

export default ConsentList;
